import { messages as localMessages, messages } from '@/components/banners/BannerFinancingOffer/messages'
import type { ICustomizedFormStepProps } from '@/components/composed/forms/CustomizedForms/interfaces'

export const bannerFinancingOrderFormAdapter = (steps: ICustomizedFormStepProps[], onMoreClick: () => void): ICustomizedFormStepProps[] =>
  steps.map(step => ({
    ...step,
    title: undefined,
    titleId: undefined,
    calcButton: { textId: messages.actions.more, modifiers: ['outline-gray', 'full-width-mobile'], onClick: onMoreClick },
    submitButton: {
      ...step.submitButton,
      textId: localMessages.actions.sendOrder,
      modifiers: ['green', 'full-width-mobile'],
    },
  }))
